import { useLocalStorageJSON } from 'common/hooks';

import { PreviousEntitySelection } from '../types';

const MAX_PREVIOUS_SELECTIONS = 5;

export const usePreviousEntitySelections = () => {
  const [previousEntitySelections, setPreviousEntitySelections] = useLocalStorageJSON<PreviousEntitySelection[]>(
    'previousEntitySelections',
    [],
  );

  const pushEntitySelection = (entity: PreviousEntitySelection) => {
    const existingSelections = previousEntitySelections.filter(selection => selection.slug !== entity.slug);
    const newSelections = [entity, ...existingSelections];
    setPreviousEntitySelections(newSelections.slice(0, MAX_PREVIOUS_SELECTIONS));
  };

  return {
    previousEntitySelections,
    pushEntitySelection,
  };
};
